import { useState } from "react";

// False until `open` is first true, then true for good. Application mounts a gated lazy container
// once its latch is set and keeps it mounted, so the container's own close effects (`hideModal`,
// state resets) still run and its chunk is never requested before the first open (PLAY-5251
// design D2).
export function useLatch(open: boolean): boolean {
  const [latched, setLatched] = useState(open);

  if (open && !latched) {
    setLatched(true);
  }

  return latched || open;
}

export default useLatch;
